import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, catchError, Observable, tap } from 'rxjs';
import { StorageService } from '../shared/services/storage.service';
import { UserI } from '../shared/models/user.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userSubject = new BehaviorSubject<UserI | null>(null);
  user$: Observable<UserI | null> = this.userSubject.asObservable();
  private tokensSubject!: BehaviorSubject<{token: string; pin_token: string}>;
  private readonly baseUrl = environment.baseUrl;

  
  constructor(
    private http: HttpClient,
    private storageSrv: StorageService,
  ) { 
    this.tokensSubject =  new BehaviorSubject(this.getTokens);
  }

  getUserProfile(tokens: {token: string; pin_token: string}) {
    const headers = {
      Authorization: `Bearer ${tokens.token}`,
      'pin-token': tokens.pin_token
    }    
    return this.http.get(`${this.baseUrl}/users/profile`, {headers})
  }
  getLatestUserDetails() {
    const { token, pin_token } = this.getTokens;
    const headers = {
      Authorization: `Bearer ${token}`,
      'pin-token': pin_token
    }
    this.userSubject.next(null);
    return this.http.get(`${this.baseUrl}/users/profile`, {headers}).pipe(
      tap((resp: any) => {
        const user = resp.data.user;        
        this.userSubject.next(user);
      }),
      catchError(error => {
        console.error('Error fetching user details:', error);
        throw error;
      })
    )
  }

  setUserLoggedIn(tokens: {token: string; pin_token: string}) {
    this.tokensSubject.next(tokens);
    this.storageSrv.setItem('token', tokens.token)
    this.storageSrv.setItem('pin_token', tokens.pin_token)
  }
  get isUserLoggedIn() {
    const { token, pin_token } = this.getTokens;
    if (token && pin_token) {
      return true;
    } else {
      return false;
    }
  }

  get getTokens () {
    const ls_token = this.storageSrv.getItem('token') ?? ''
    const ls_pin_token = this.storageSrv.getItem('pin_token') ?? ''
    const token = this.tokensSubject?.value?.token || ls_token;
    const pin_token = this.tokensSubject?.value?.pin_token || ls_pin_token;
    return {token, pin_token};
  }
  logout() {
    this.tokensSubject.next({token: '', pin_token: ''});
    this.storageSrv.removeItem('token')
    this.storageSrv.removeItem('pin_token')
  }
}
